import { Brain, ShieldCheck, BarChart, Users } from "lucide-react";

function Features() {
  return (
    <section className="section ">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Potential Applications
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            WholeFoods.ai opens doors to numerous innovative applications in the
            food and nutrition space.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="card p-8 flex">
            <div className="mr-6">
              <div className="bg-secondary/10 rounded-full w-12 h-12 flex items-center justify-center">
                <Brain className="h-6 w-6 text-secondary" />
              </div>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">
                AI-Powered Nutrition Planning
              </h3>
              <p className="text-gray-600">
                Personalized meal plans and nutrition advice based on individual
                health data, preferences, and goals.
              </p>
            </div>
          </div>

          <div className="card p-8 flex">
            <div className="mr-6">
              <div className="bg-secondary/10 rounded-full w-12 h-12 flex items-center justify-center">
                <ShieldCheck className="h-6 w-6 text-secondary" />
              </div>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">
                Food Safety & Quality Control
              </h3>
              <p className="text-gray-600">
                AI systems for detecting contaminants, ensuring quality, and
                maintaining safety standards.
              </p>
            </div>
          </div>

          <div className="card p-8 flex">
            <div className="mr-6">
              <div className="bg-secondary/10 rounded-full w-12 h-12 flex items-center justify-center">
                <BarChart className="h-6 w-6 text-secondary" />
              </div>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">
                Supply Chain Optimization
              </h3>
              <p className="text-gray-600">
                Predictive analytics for inventory management, reducing waste,
                and ensuring freshness.
              </p>
            </div>
          </div>

          <div className="card p-8 flex">
            <div className="mr-6">
              <div className="bg-secondary/10 rounded-full w-12 h-12 flex items-center justify-center">
                <Users className="h-6 w-6 text-secondary" />
              </div>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">
                Community Health Initiatives
              </h3>
              <p className="text-gray-600">
                AI-driven platforms for community engagement around sustainable
                food practices and health.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
